import React from "react";
import { IoIosArrowBack } from "react-icons/io";
import logo from "../../assets/icons/NewLogo.png";
import "../../styles/OverlayHeader.css";

export default function OverlayHeader({ onBack }) {
  return (
    <header className="overlay-header">
      <div className="overlay-left">
        <button className="back-button" onClick={onBack}>
          <IoIosArrowBack size={24} />
        </button>
      </div>

      <div className="overlay-center">
        <img src={logo} alt="PrashaSync Logo" className="overlay-logo" />
      </div>
    </header>
  );
}
